var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile information--how-to"},[_c('p',{staticClass:"content__heading"},[_vm._v("How To")]),_c('div',{staticClass:"accordian"},_vm._l((_vm.getHowTos),function(item){return _c('Fold',{key:item.id,attrs:{"item":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }